module.exports = __webpack_public_path__ + "static/media/boxes.e66f59df.svg";